// Messages de validation communs à tous les domaines (API et formulaires du BO), sans dépendance :
// un module de domaine (logistique, adresse…) les importe, jamais l'inverse.

/** Texte trop long : même message partout. */
export const maxLengthMessage = (max: number): string => `${max} caractères au plus.`
